export default {
    path: 'air-ticket',
    component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
    children: [
      {
            path: 'international-pay',
            name: 'international-pay',
            component: () => import('./index.vue'),
      },
    ]
  };
